import { mainSearch, update } from "../../../../components/indexDB/indexDBStora";
import { calculate_qty_depending_on_type } from "./convertorMeasures";

export const UpdateBatchQty = async (meta, transaction) => {
        const res = {
            status: false,
            message: ""
        };
        if(!meta || !transaction) {
            res.message = "missing data";
            return res;
        }
    try {
        const batch = await mainSearch(
            "batches",
            transaction.batchId
        );
        if (!batch) {
            res.message = "Batch not found";
            return res;
        }
        
        const result = calculate_qty_depending_on_type(meta.type, transaction.qty, meta.boxes);
        const qty = Number(result.total);
        if (!qty || qty <= 0) {
            res.message = "Invalid quantity";
            return res;
        }

        batch.currentQty = Number(batch.currentQty || 0);
        if (transaction.transactionType === "IN") {
            batch.currentQty += qty;
        } 
        else if (["OUT","ADJUSTMENT"].includes(transaction.transactionType)) {
            if (batch.currentQty < qty) {
                res.message = "Quantity exceeds available stock";
                return res;
            }

            batch.currentQty -= qty;
        }
        await update("batches", batch);

        return {
            status: true,
            message: result
        };
        
    } catch (error) {
        console.log(error);
        res.message = error.message || "Failed to update batch quantity";
        return res;
    }
};